import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { LAND_STATUSES_MAP_VALUE_TO_LABEL } from './constants';

export const landStatusTagsManager = createTermsTagsManager({
  jsonQueryKey: 'land_status',
  mapValueToLabel: LAND_STATUSES_MAP_VALUE_TO_LABEL,
  id: 'landStatus',
});
